<template>
  <div class="category">
    <router-link
      :to="{ name: r_name, params: { id: category_id } }"
      @click.native="$store.commit('setChildrenView', true)"
    >
      <div class="category__icon">
        <img
          v-if="icon === '' || icon === 'default_icon'"
          src="/images/pic.svg"
        />
        <img v-else :src="icon.url" />
      </div>
      <h2><div class="category__title">{{ title }}</div></h2>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Category",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      default: "default_icon",
    },
    category_id: {
      type: Number,
      required: true,
    },
    r_name: {
      default: "category",
      type: String,
    },
  },
};
</script>
